export const LS_AUTH_TOKEN_KEY = "auth_token";
export const CUSTOMIZATION_SET_EVENT = "customization-set";
export const CUSTOMIZATION_LOCAL_STORAGE_KEY = "customization";
export const SESSION_LOCAL_STORAGE_KEY = "session";
export const SESSION_LANG_STORAGE_KEY = "lang-session";
